import React, { useEffect, useState } from "react";
import authStorage from "../utils/authStorage";
import axios from "axios";
import { BASE_URL, FITBIT_CLIENT_ID } from "../config";
import Modal from "../components/modal";
import Calendar from "../components/calendar";
import Tooltip from "../components/tooltip";
import { useNavigate, useSearchParams } from "react-router-dom";
import SamsungUrl from "../assets/samsung_logo.png";
import bluetoothConnect from "../assets/images/bluetoothConnect.svg"
import bluetoothDisabled from "../assets/images/bluetoothDisabled.svg"
import fitbitIcon from "../assets/images/fitbitIcon.svg"
import garminIcon from "../assets/images/garminIcon.svg"
import samsungIcon from "../assets/samsung_logo.png"
import { FEATURE, loadFeatureFlags, isFeatureEnabled } from "../utils/featureFlags";

const Devices = () => {
  const navigate = useNavigate();

  useEffect(() => {
  let subscribedStatus = authStorage.getItem('subscribedStatus');
      
  // If subscribedStatus is falsy, redirect to membership page
  if (subscribedStatus == 'false') {
      window.location = window.location.origin + '/membership';
      return false;
  }
})

  const [fitbitChecked, setFitbitChecked] = useState(false);
  const [garminChecked, setGarminChecked] = useState(false);
  const [stravaChecked, setStravaChecked] = useState(false);
  const [samsungChecked, setSamsungChecked] = useState(false);
  const [fitbitConnectLoading, setFitbitConnectLoading] = useState(false);
  const [deviceStatusLoading, setDeviceStatusLoading] = useState(true);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [deviceType, setDeviceType] = useState();
  const [user, setUser] = useState({});
  // 'connected' | 'needs_reauth' | 'disconnected'. Served by /user/device/status.
  // OAuth2 refresh tokens expire (~90 days), so "connected" is no longer binary.
  const [garminStatus, setGarminStatus] = useState('disconnected');
  const [samsungConnected, setSamsungConnected] = useState(false);
  const [samsungBusy, setSamsungBusy] = useState(false);
  const [samsungLinkCopied, setSamsungLinkCopied] = useState(false);
  // null until the flag map arrives. isFeatureEnabled reads null as ENABLED, so
  // a slow or failed request shows the card as it was rather than hiding a
  // working integration - the same fail-open default the server uses.
  const [featureFlags, setFeatureFlags] = useState(null);
  const showSamsungCard = isFeatureEnabled(FEATURE.SAMSUNG_CONNECT, featureFlags);
  const [garminConnectLoading, setGarminConnectLoading] = useState(false);
  const [garminError, setGarminError] = useState('');
  // true | false | null. null means the API has not read the permission set back
  // from Garmin yet, which must NOT be shown as "historical data is off".
  const [garminHistoricalEnabled, setGarminHistoricalEnabled] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    let cancelled = false;
    loadFeatureFlags().then((f) => { if (!cancelled) setFeatureFlags(f); });
    return () => { cancelled = true; };
  }, []);

  const onClickFitbit = () => {
    if (fitbitConnectLoading) {
      return;
    }
    if (fitbitChecked) {
      modelDeviceType('FitBit');
      setConfirmationModal(true);
    } else {
      //setFitbitChecked(true);
      setFitbitConnectLoading(true);
      window.location.href = `https://www.fitbit.com/oauth2/authorize?client_id=${FITBIT_CLIENT_ID}&response_type=code&scope=activity%20heartrate%20location%20nutrition%20oxygen_saturation%20profile%20respiratory_rate%20settings%20sleep%20social%20temperature%20weight%20cardio_fitness%20electrocardiogram%20heartrate`;
    }
  };

  // Starts the Garmin OAuth2 (PKCE) flow. The verifier and CSRF state live
  // server-side, so the browser only ever follows the returned consent URL.
  // Also used by the "Reconnect" action when the refresh token has expired.
  const startGarminAuthorization = () => {
    if (garminConnectLoading) {
      return;
    }
    setGarminError('');
    setGarminConnectLoading(true);
    axios({
      headers: {
        "x-access-token": authStorage.getItem("auth-token"),
      },
      url: `${BASE_URL}/garmin/oauth2/authorize`,
      method: "POST",
    }).then((res) => {
      if (res?.data?.redirectUrl) {
        window.location.href = res.data.redirectUrl;
      } else {
        setGarminConnectLoading(false);
        setGarminError('Could not start Garmin authorization. Please try again.');
      }
    }).catch(() => {
      // The previous version had no catch, so a Garmin or network failure left
      // the button looking like a dead click.
      setGarminConnectLoading(false);
      setGarminError('Could not reach Garmin. Please try again.');
    });
  };

  const onClickGarmin = () => {
    if (garminConnectLoading) {
      return;
    }
    // While connected the toggle means "disconnect", so re-running consent to
    // add a permission needs its own entry point (startGarminAuthorization).
    if (garminStatus === 'connected') {
      modelDeviceType('Garmin');
      setConfirmationModal(true);
      return;
    }
    startGarminAuthorization();
  };

  const onModalConfirm = () => {
    setFitbitChecked(false);

    if (deviceType == 'Garmin') {
      removeGarminUSer();
    }
    if (deviceType == 'FitBit') {
      removeFitBitToken();
    }


  };

  const removeFitBitToken = () => {
    axios({
      headers: {
        "x-access-token": authStorage.getItem("auth-token"),
      },
      url: `${BASE_URL}/auth/removeFitBitToken`, //your url
      method: "PUT",
    }).then((res) => {
      setConfirmationModal(false);
      getDeviceStatus();
    });
  };
  const removeGarminUSer = () => {
    setGarminError('');
    axios({
      headers: {
        "x-access-token": authStorage.getItem("auth-token"),
      },
      url: `${BASE_URL}/auth/removegarmin`, //your url
      method: "PUT",
    }).then((res) => {
      setConfirmationModal(false);
      getDeviceStatus();
    }).catch(() => {
      // Previously errors were swallowed and the UI reported success anyway.
      setConfirmationModal(false);
      setGarminError('Could not disconnect from Garmin. Please try again.');
      getDeviceStatus();
    });
  };
  /*
   * PLACEHOLDERS -- the Android team must confirm both before this ships.
   *
   * SAMSUNG_APP_PACKAGE is the CFT Connect Android package name and
   * SAMSUNG_DEEP_LINK_PATH is the in-app route that opens the Samsung Health
   * connection screen. Neither appears anywhere in this repo, so both are
   * guesses. A wrong package does not error -- it silently falls through to the
   * Play Store, which looks like it worked.
   */
  const SAMSUNG_APP_PACKAGE = 'com.contingentfitness.connect';
  const SAMSUNG_DEEP_LINK_PATH = 'devices/samsung';

  /*
   * An `intent://` URL rather than a bare custom scheme.
   *
   * A custom scheme (cftconnect://...) does nothing on a device without the app
   * -- the browser reports an unknown protocol and the member is stuck. The
   * intent form carries a browser_fallback_url, so someone without the app lands
   * on the Play Store listing instead of a dead end.
   *
   * Android only, which is correct here: Samsung Health is read through an
   * Android SDK, so an iPhone cannot connect at all and the card says so rather
   * than offering a button that cannot work.
   */
  const samsungPlayStoreUrl = `https://play.google.com/store/apps/details?id=${SAMSUNG_APP_PACKAGE}`;
  const samsungDeepLink =
    `intent://${SAMSUNG_DEEP_LINK_PATH}#Intent;scheme=cftconnect;package=${SAMSUNG_APP_PACKAGE};` +
    `S.browser_fallback_url=${encodeURIComponent(samsungPlayStoreUrl)};end`;

  const isAndroid = /android/i.test(navigator.userAgent || '');
  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent || '');

  const copySamsungLink = () => {
    const done = () => {
      setSamsungLinkCopied(true);
      setTimeout(() => setSamsungLinkCopied(false), 2500);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(samsungPlayStoreUrl).then(done).catch(() => {});
    } else {
      // execCommand is deprecated but is the only route on an insecure origin,
      // which is exactly where this page runs in local development.
      const el = document.createElement('textarea');
      el.value = samsungPlayStoreUrl;
      document.body.appendChild(el);
      el.select();
      try { document.execCommand('copy'); done(); } catch (e) { /* ignore */ }
      el.remove();
    }
  };

  /*
   * Disconnect is the one Samsung action that CAN happen from the web: it only
   * clears a flag, with nothing to revoke at Samsung's end. Connecting cannot --
   * permission is granted by Samsung Health's own dialog on the phone, and there
   * is no web authorisation page to send anyone to.
   */
  const disconnectSamsung = () => {
    setSamsungBusy(true);
    axios({
      headers: { "x-access-token": authStorage.getItem("auth-token") },
      url: `${BASE_URL}/samsung/connect`,
      method: 'POST',
      data: { connected: false },
    })
      .then(() => { setSamsungConnected(false); })
      .catch(() => { /* leave the state as it was */ })
      .finally(() => setSamsungBusy(false));
  };

  const getDeviceStatus = () => {
    setDeviceStatusLoading(true);
    axios({
      headers: {
        "x-access-token": authStorage.getItem("auth-token"),
      },
      url: `${BASE_URL}/user/device/status`, //your url
      method: "GET",
    }).then((res) => {
      setDeviceStatusLoading(false);
      setFitbitChecked(res.data.isFitbitConnected);
      // garminStatus is the authoritative field. Fall back to the legacy
      // boolean so this page still works against an API that predates it.
      const status = res.data.garminStatus
        || (res.data.isGarminConnected ? 'connected' : 'disconnected');
      setGarminStatus(status);
      setGarminChecked(status === 'connected');
      setSamsungConnected(Boolean(res.data.isSamsungConnected));
      // undefined from an older API build is treated the same as "unknown".
      setGarminHistoricalEnabled(
        res.data.garminHistoricalDataEnabled === undefined
          ? null
          : res.data.garminHistoricalDataEnabled
      );
    }).catch((err) => {
      if(err.code == "ERR_BAD_REQUEST"){ // Unauthorized 401
        //console.log("Error : ", err.code);
        authStorage.clear(); // Remove token from local storage
        navigate('/'); // Redirect to the login page
      }
    });
  };

  const getProfile = (event) => {
    axios({
      headers: {
        "x-access-token": authStorage.getItem("auth-token"),
      },
      url: `${BASE_URL}/user/profile`, //your url
      method: 'GET'
    }).then((res) => {
      setUser(res?.data?.data);
    }).catch((err) => {
      if(err.code == "ERR_BAD_REQUEST"){ // Unauthorized 401
        //console.log("Error : ", err.code);
        authStorage.clear(); // Remove token from local storage
        navigate('/'); // Redirect to the login page
      }
    });
  };

  useEffect(() => {
    getDeviceStatus();
    getProfile();
  }, []);

  // Return trip from Garmin. The API redirects here as
  // /device?garmin=connected|denied|error. Read it once, tell the user, then
  // strip the param so a refresh does not replay the message.
  useEffect(() => {
    const result = searchParams.get('garmin');
    if (!result) {
      return;
    }
    if (result === 'connected') {
      getDeviceStatus();
    } else if (result === 'denied') {
      setGarminError('Garmin authorization was cancelled.');
    } else {
      setGarminError('Garmin connection failed. Please try again.');
    }
    searchParams.delete('garmin');
    setSearchParams(searchParams, { replace: true });
  }, []);

  const updateWalkthrough = (e) => {
    axios({
      headers: {
        "x-access-token": authStorage.getItem("auth-token"),
      },
      url: `${BASE_URL}/user/update/walkthrough`, //your url
      method: 'PUT',
      data: { walkThroughPending: false, walkThroughSteps: 2 }
    }).then((res) => {
      authStorage.setItem('walkthrough', JSON.stringify({ walkThroughPending: false, walkThroughSteps: 2 }))
    }).catch((err) => {
    });
  };

  function modelDeviceType(deviceType) {
    setDeviceType(deviceType);
  };

  const onClickViewDashboard = () => {
    if (garminChecked || fitbitChecked) {
      navigate('/dashboard');
      updateWalkthrough();
    }
  };

  const walkThroughPending = JSON.parse(authStorage.getItem("walkthrough")?.walkThroughPending ?? false)?.walkThroughPending;

  return (
    <div
      className="dark:bg-slate-900"
      style={{ height: "100vh" }}
    >
      <Modal
        title={"Disconnect Device"}
        content={"Do you really want to disconnect device ?"}
        modalShow={confirmationModal}
        onModalConfirm={onModalConfirm}
        setModalShow={setConfirmationModal}
        deviceType={deviceType}
      />
      <div className="w-full p-5 ">
      <h2 className="mob-header font-medium mb-3">Device</h2>
        <div className="px-2 devices-col-section">
          {/* <div className="flex align-center items-center justify-between border-b border-blue-200 border-opacity-20 h-14 mb-8">
            <div className="text-2xl tracking-tight font-medium text-gray-300 dark:text-white">
              Devices
            </div>
          </div> */}
          {/* items-stretch keeps both cards the same height, and each card is a
              column whose action row is pushed down by the flex-1 body -- so the
              Connect/Disconnect buttons line up even when one card carries an
              extra notice (e.g. the Garmin Historical Data prompt). */}
          <ul role="list" className="flex list-none gap-5 items-stretch">
            <li
              className={`p-3 bg-white w-3/12 text-center col-box flex flex-col ${(fitbitConnectLoading || deviceStatusLoading) && "opacity-40"
                } p-2 rounded my-2`}
            >
              <div className="flex flex-col flex-1">
                <div className="icon-box">
                  <img
                   src={fitbitIcon}
                   alt="Neil image"
                  />
                </div>
                <div className="flex-1">
                  <p className="font-medium text-black truncate dark:text-white mt-3">
                    FITBIT
                  </p>
                  {(fitbitConnectLoading || deviceStatusLoading) ? (
                    <div className="lds-facebook">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  ) : (
                    <p className="text-gray-500 text-xs truncate dark:text-gray-400 bg-[36353880] mb-4">
                      {fitbitChecked ? "connected" : "disconnected"}
                    </p>
                  )}
                </div>
                <div className="mt-auto items-center text-base font-medium text-gray-600 dark:text-white">
                  <label className="relative items-center cursor-pointer">
                    <input
                      onClick={onClickFitbit}
                      type="checkbox"
                      value=""
                      className="sr-only peer"
                      checked={fitbitChecked}
                    />
                    {/* <div className="w-11 h-6 bg-gray-300 peer-checked:bg-[#415E96] rounded-full dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-gray-700 after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-gray-100 after:border-gray-400 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600"></div> */}
                    <div className={fitbitChecked ? "connect-box  disconect peer-checked:bg-[#e53e144d]" : "connect-box connect peer-checked:bg-[#e53e144d]"}>
              
                  <img
                    className="connect-icon"
                    src={bluetoothConnect}
                    alt="Icon"
                  />
                  <img
                    className="disconnect-icon"
                    src={bluetoothDisabled}
                    alt="Icon"
                  />
                {fitbitChecked ? "Disconnect" : "Connect"}
                </div>

                    <span className="text-sm font-medium text-gray-900 dark:text-gray-400"></span>
                  </label>
                </div>

              </div>
            </li>
            <li className={`p-3 bg-white w-3/12 text-center col-box flex flex-col ${(deviceStatusLoading) && "opacity-40"} rounded my-2`}>
              <div className="flex flex-col flex-1">
                <div className="icon-box">
                  <img
                    src={garminIcon}
                    alt="Bonnie image"
                  />
                </div>
                <div className="flex-1">
                  <p className="font-medium text-black truncate dark:text-white mt-3">
                    <div className="">
                      GARMIN
                      {(!user?.weight || !user?.age || !user?.gender || !user?.height) && (<Tooltip text={<span>Update your details on <span onClick={() => navigate('/profile')} className="cursor-pointer font-medium text-blue-400 dark:text-blue-500 underline" href='www.google.com'>profile</span></span>}>
                        {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="yellow" class="cursor-pointer w-6 h-6 ml-4">
                          <path stroke-linecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                        </svg> */}
                      </Tooltip>
                      )}
                    </div>
                  </p>
                  {(deviceStatusLoading || garminConnectLoading) ? (
                    <div className="lds-facebook">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  ) : (
                    <p className={`text-xs truncate mb-4 bg-[36353880] ${garminStatus === 'needs_reauth' ? 'text-amber-600 font-medium' : 'text-gray-500 dark:text-gray-400'}`}>
                      {garminStatus === 'connected' && "connected"}
                      {garminStatus === 'needs_reauth' && "reconnect needed"}
                      {garminStatus === 'disconnected' && "disconnected"}
                    </p>
                  )}
                  {garminStatus === 'needs_reauth' && !deviceStatusLoading && (
                    // A Garmin refresh token expires (~90 days). Without this the
                    // user's data would simply stop syncing with no explanation.
                    <p className="text-amber-600 text-xs mb-3 px-1">
                      Your Garmin authorization expired. Reconnect to resume syncing.
                    </p>
                  )}
                  {garminStatus === 'connected'
                    && garminHistoricalEnabled === false
                    && !deviceStatusLoading && (
                    // Garmin ships the "Historical Data" toggle OFF and gives the
                    // app no way to pre-select it, so workouts recorded before
                    // connecting cannot be imported until the user turns it on
                    // themselves. Explicitly false only -- null means unknown.
                    <div className="mb-3 px-1">
                      <p className="text-amber-600 text-xs mb-2">
                        Turn on <span className="font-medium">Historical Data</span> permission
                      </p>
                      <button
                        type="button"
                        onClick={startGarminAuthorization}
                        disabled={garminConnectLoading}
                        className="inline-flex items-center gap-1.5 rounded-full border border-amber-300 bg-amber-50 px-3 py-1.5 text-xs font-semibold text-amber-700 shadow-sm transition-all duration-150 hover:bg-amber-100 hover:border-amber-400 hover:shadow active:scale-95 focus:outline-none focus:ring-2 focus:ring-amber-300 focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-amber-50 disabled:active:scale-100"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          className="w-3.5 h-3.5"
                          aria-hidden="true"
                        >
                          <path
                            fillRule="evenodd"
                            d="M15.312 11.424a5.5 5.5 0 01-9.201 2.466l-.312-.311h2.433a.75.75 0 000-1.5H3.989a.75.75 0 00-.75.75v4.242a.75.75 0 001.5 0v-2.43l.31.31a7 7 0 0011.712-3.138.75.75 0 00-1.449-.389zm1.23-3.723a.75.75 0 00.219-.53V2.929a.75.75 0 00-1.5 0V5.36l-.31-.31A7 7 0 003.239 8.188a.75.75 0 101.448.389A5.5 5.5 0 0113.89 6.11l.311.31h-2.432a.75.75 0 000 1.5h4.243a.75.75 0 00.53-.219z"
                            clipRule="evenodd"
                          />
                        </svg>
                        Update Permissions
                      </button>
                    </div>
                  )}
                  {garminError && (
                    <p className="text-red-500 text-xs mb-3 px-1">{garminError}</p>
                  )}
                </div>
                <div className="mt-auto items-center text-base font-medium text-gray-600 dark:text-white">
                  <label className="relative items-center cursor-pointer">
                    <input
                      onClick={onClickGarmin}
                      type="checkbox"
                      value=""
                      className="sr-only peer"
                      checked={garminChecked}
                      // disabled={garminChecked}
                    />
                    {/* <input onClick={() => setGarminChecked(!garminChecked)} type="checkbox" value="" className="sr-only peer" checked={garminChecked} /> */}
                    {/* <div className="w-11 h-6 bg-gray-300 peer-checked:bg-[#415E96] rounded-full dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-gray-700 after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-gray-100 after:border-gray-400 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600"></div> */}
                    {/* <div className="connect-box connect peer-checked:bg-[#e53e144d]"> */}
                    <div className={garminStatus === 'connected' ? "connect-box  disconect peer-checked:bg-[#e53e144d]" : "connect-box connect peer-checked:bg-[#e53e144d]"}>
                  <img
                    className="connect-icon"
                    src={bluetoothConnect}
                    alt="Icon"
                  />
                  <img
                    className="disconnect-icon"
                    src={bluetoothDisabled}
                    alt="Icon"
                  />
                 {garminStatus === 'connected' && "Disconnect"}
                 {garminStatus === 'needs_reauth' && "Reconnect"}
                 {garminStatus === 'disconnected' && "Connect"}
                </div>
                    <span className="text-sm font-medium text-gray-900 dark:text-gray-400"></span>
                  </label>
                </div>





              </div>
            </li>

            {/* Hidden entirely when an admin switches `samsungConnect` off. The
                server refuses the connect request as well, so hiding the card is
                not the only thing standing between a member and a half-finished
                connection. Disconnect stays available to the app. */}
            {showSamsungCard && (
            <>
            {/* Samsung Health. No Connect button BY DESIGN: the Samsung Health
                Data SDK is an on-device Android library, so permission is granted
                in Samsung Health's own dialog inside the CFT app. There is no
                Samsung authorisation webpage to redirect to, unlike Fitbit and
                Garmin. The deep link is the closest the web can get -- it hands
                the member to the app at the right screen. */}
            <li className={`p-3 bg-white w-3/12 text-center col-box flex flex-col ${(deviceStatusLoading) && "opacity-40"} rounded my-2`}>
              <div className="flex flex-col flex-1">
                <div className="icon-box">
                  <img src={samsungIcon} alt="Samsung Health" style={{ maxHeight: '38px', objectFit: 'contain' }} />
                </div>
                <div className="flex-1">
                  <p className="font-medium text-black truncate dark:text-white mt-3">SAMSUNG HEALTH</p>

                  {deviceStatusLoading ? (
                    <div className="lds-facebook"><div></div><div></div><div></div><div></div><div></div></div>
                  ) : samsungConnected ? (
                    <p className="mt-2 text-xs" style={{ color: '#00C98E' }}>Connected</p>
                  ) : (
                    <p className="mt-2 text-xs text-gray-400">Not connected</p>
                  )}

                  {!deviceStatusLoading && !samsungConnected && (
                    <div className="mt-3 text-left">
                      {isIOS ? (
                        <p className="text-xs leading-relaxed text-gray-500">
                          Samsung Health can only be connected from an Android phone.
                        </p>
                      ) : (
                        <>
                          <a
                            href={samsungDeepLink}
                            className="inline-flex w-full items-center justify-center gap-2 border-0 px-3 py-2 text-xs font-semibold text-white no-underline"
                            style={{ background: '#E53E14', borderRadius: '8px' }}
                          >
                            Open in CFT app
                          </a>
                          <p className="mt-2 text-[11px] leading-relaxed text-gray-500">
                            {isAndroid
                              ? 'Opens the CFT app on this phone. Samsung Health must be installed and signed in.'
                              : 'On your Android phone, open the CFT app and connect Samsung Health there.'}
                          </p>
                          {!isAndroid && (
                            <button
                              type="button"
                              onClick={copySamsungLink}
                              className="mt-1.5 cursor-pointer border-0 bg-transparent p-0 text-[11px] font-medium appearance-none underline"
                              style={{ color: '#0694F3' }}
                            >
                              {samsungLinkCopied ? 'App link copied' : 'Copy app link'}
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  )}

                  {!deviceStatusLoading && samsungConnected && (
                    <button
                      type="button"
                      onClick={disconnectSamsung}
                      disabled={samsungBusy}
                      className="mt-3 w-full cursor-pointer border border-solid border-gray-300 bg-white px-3 py-2 text-xs font-medium text-gray-700 appearance-none disabled:opacity-60"
                      style={{ borderRadius: '8px' }}
                    >
                      {samsungBusy ? 'Disconnecting...' : 'Disconnect'}
                    </button>
                  )}
                </div>
              </div>
            </li>
            </>
            )}
          </ul>
        </div>
      </div>
    </div>

  );
};
export default Devices;
